import { useErrorMessage } from '@nucleus-commerce/admin-kit/errors';
import { Alert, AlertDescription } from '@nucleus-commerce/ui/components/alert';

/** Inline error for auth forms (they opt out of the global toast). */
export function ServerError({ error }: { error: unknown }) {
  const message = useErrorMessage();
  if (error === null || error === undefined) return null;
  return (
    <Alert variant="destructive">
      <AlertDescription>{message(error)}</AlertDescription>
    </Alert>
  );
}
